'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _ElementConnectionsRegistry = require('./ElementConnectionsRegistry');

var _ElementConnectionsRegistry2 = _interopRequireDefault(_ElementConnectionsRegistry);

var _configureElementConnectionsStore = require('./configureElementConnectionsStore');

var _configureElementConnectionsStore2 = _interopRequireDefault(_configureElementConnectionsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // Registry


// Store configuration


/**
 * Holds a reference to the store and the registry.
 * Also provides a method to subscribe to the store.
 */
var ElementConnectionsManager = function ElementConnectionsManager() {
    var _this = this;

    _classCallCheck(this, ElementConnectionsManager);

    this.subscribeToStateChange = function (listener) {
        return (
            // TODO probably a lot of performance improvements to be done here
            _this.store.subscribe(listener)
        );
    };

    this.registry = new _ElementConnectionsRegistry2.default();
    this.store = (0, _configureElementConnectionsStore2.default)();
}

/**
 * Subscribes the listener function to any elementConnections state changes.
 * Returns a method to unsubscribe.
 */
;

exports.default = ElementConnectionsManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/ElementConnectionsManager.js
// module id = 1703
// module chunks = 0